
export const NTW_TYPE = {
    1: '门店',
    2: '集团',
    3: '部落'
} as const

export const NTW_VERSION = {
    basic: '基础版',
    oldTrial: '老系统-试用版',
    oldPro: '老系统-专业版',
    oldFree: '老系统-免费版',
    mkt: '营销版本',
    scrm: 'SCRM版本'
}
export const TabList = [
    {
        id: '1',
        imageUrl: "https://js.dingdandao.com/library/help-center/images/Question1.png",
        title: "问题汇总",
        path: '/Question'
    },
    {
        id: '2',
        imageUrl: "https://js.dingdandao.com/library/help-center/images/Video.png",
        title: "视频资料",
        path: '/Video'
    },
    {
        id: '3',
        imageUrl: "https://js.dingdandao.com/library/help-center/images/Novice.png",
        title: "新手专区",
        path: '/Novice'
    },
    {
        id: '4',
        imageUrl: "https://js.dingdandao.com/library/help-center/images/Download.png",
        title: "下载中心",
        path: '/Download'
    }
]